export default import.meta.ROLLDOWN_FILE_URL__THqpcSAZd2CElPvQn3hZg